







































import { TermSuccessDataPoint } from '@empathybroker/tsclient-stats/dist/models/termsuccessreport/termsuccessdata-point';

import { mapActions, mapGetters } from 'vuex';

import { ApiEnum } from '../../enums';

import { Pagination } from '../../models';

import { ANALYTICS_CONSTS } from '../../store/analytics/analytics.consts';

import PaginationBar from '../crud/pagination-bar.component.vue';
import Searchbox from '../searchbox.component.vue';
import ItemsList from './items-list.component.vue';

export default {
  name: 'search',
  props: {
    query: String
  },
  components: {
    Searchbox,
    ItemsList,
    PaginationBar
  },
  computed: {
    ...mapGetters(ANALYTICS_CONSTS.moduleName, {
      data: ANALYTICS_CONSTS.getters.data,
      selectedId: ANALYTICS_CONSTS.getters.selectedId
    }),
    searchData: function () {
      return this.data.search[this.query];
    },
    results: function () {
      if (!this.searchData) {
        return [];
      }
      return this.searchData.data.map((searchDataItem: TermSuccessDataPoint) => ({
        id: searchDataItem.terms,
        count: searchDataItem.queryCount,
        percentage: ((searchDataItem.queryCount / this.searchData.queryCount) * 100)
      }));
    }
  },
  data: function (): Object {
    return {
      pagination: {
        page: 1,
        itemsPerPage: 5,
        totalItems: 0
      },
      loading: false,
      messages: this.$epb.messages.analytics.queries
    };
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      loadSearchData: ANALYTICS_CONSTS.actions.loadSearchData
    }),
    loadData: async function (resetPagination = false): Promise<void> {
      if (resetPagination) {
        this.pagination.page = 1;
      }
      this.loading = true;
      try {
        const searchData = await this.loadSearchData(this.pagination);
        this.pagination.totalItems = (!!searchData ? searchData.termsCount : 0);
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
      } finally {
        this.loading = false;
      }
    },
    onQueryChange: function (newValue): void {
      this.$emit('queryChange', newValue);
    },
    onPaginationChange: function (pagination: Pagination): void {
      this.pagination = pagination;
      this.loadData();
    }
  },
  created: function (): void {
    if (!!this.query) {
      this.loadData();
    }
  },
  watch: {
    query: function (query: string): void {
      if (!!query) {
        this.loadData(true);
      }
    }
  }
};

